import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TUserClient, TUserClientResponse, adaptUserClientFromResponse } from '../../types';
import { BACKEND_USER_CLIENT } from '../../backend-paths';


export const userClientReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_USER_CLIENT}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_USER_CLIENT}/${payload}`;

		return HttpService.get<TUserClientResponse>(path).then(result => {
			return adaptUserClientFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TUserClient> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userClientReadSlice = createSlice({
	name: 'userClientReadSlice',
	initialState,
	reducers: {
		setUserClientRead(state, action: PayloadAction<TUserClient>) {
			state.item = action.payload;
		},

		clearUserClientRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userClientReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userClientReadGetApi.fulfilled.type]: (state, action: PayloadAction<TUserClient>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userClientReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserClientReadSelector = () => useAppSelector(state => state[userClientReadSlice.name]);

export const { clearUserClientRead, setUserClientRead } = userClientReadSlice.actions;
